<template>
  <div ref="slider" class="home-slider">
    <v-card
      v-for="img in images" :key="img.image"
      class="home-slider--slide" tile flat
      :href="img.href" target="_blank" rel="noopener noreferrer"
    >
      <v-img :src="img.image" :aspect-ratio="3.6" />
    </v-card>
  </div>
</template>

<script>
import Flickity from 'flickity'
import 'flickity/dist/flickity.min.css'

export default {
  props: {
    user: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      flickity: null,
    }
  },
  computed: {
    images() {
      return [
        {
          image: 'https://i.imgur.com/KfXZ7zi.jpg',
          onClick: () => {
            this.$router.push({ name: 'Crate Battles' })
          },
        },
        {
          image: 'https://media.discordapp.net/attachments/892918116324085770/941406948086153266/scrap.png',
          onClick: () => {
            if (!this.user) {
              this.$modal.open('auth', { maxWidth: 320, persistent: true })
              return
            }

            this.$modal.open('promo', { maxWidth: 400 })
          },
        },
        {
          image: 'https://media.discordapp.net/attachments/892918116324085770/944280115448279090/levels.png',
          onClick: () => {
            if (!this.user) {
              this.$modal.open('auth', { maxWidth: 320, persistent: true })
              return
            }

            this.$modal.open('account', { maxWidth: 1000 })
          },
        },
        {
          image: 'https://media.discordapp.net/attachments/892918116324085770/941406948891451392/discordweb.png',
          href: 'https://discord.gg/7est6cgxtK', // custom invite link for analytics
        },
      ]
    },
  },
  mounted() {
    const { slider } = this.$refs

    this.flickity = new Flickity(slider, {
      cellAlign: 'center',
      cellSelector: '.home-slider--slide',
      prevNextButtons: true,
      pageDots: true,
      wrapAround: true,
      autoPlay: 3500,
    })

    this.flickity.on('staticClick', (event, pointer, cellElement, cellIndex) => {
      const img = this.images[cellIndex]
      img?.onClick?.(event)
    })
  },
  beforeDestroy() {
    if (this.flickity) {
      this.flickity.destroy()
    }
  },
}
</script>

<style lang="scss" scoped>
.home-slider--slide {
  width: 100%;
  margin-right: 8px;
}

.home-slider {
  &::v-deep {
    .flickity-prev-next-button {
      width: 32px;
      height: 32px;
      opacity: 0.3;
      transition: opacity 0.3s ease;
    }

    .flickity-page-dots {
      bottom: 8px;
      opacity: 0.5;
      transition: opacity 0.3s ease;

      .dot {
        background: grey(100);
      }
    }
  }

  &:hover {
    &::v-deep {
      .flickity-prev-next-button {
        opacity: 0.5;
      }

      .flickity-page-dots {
        opacity: 1;
      }
    }
  }
}

</style>
